<template>
<div class="chapter">
<div class="inner_page">
<p class="Basic-Paragraph para-style-override-8"><span class="char-style-override-6">To Mary Jo Ray, the love of my life</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?a5e9ecd2